module.exports = __webpack_public_path__ + "img/tab5@2x.4f7312cb.png";